import * as React from "react"
import { Link } from "gatsby"
import Grid from "@material-ui/core/Grid"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Container from "@material-ui/core/Container"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme, makeStyles } from "@material-ui/core"
import Drawer from "@material-ui/core/Drawer"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@mui/icons-material/Menu"
import CloseIcon from "@mui/icons-material/Close"
import image from "../images/logo.png"
import Text from "../components/typography/text"
import Button from "@material-ui/core/Button"
import logo from "../images/logo.png"

const useStyles = makeStyles({
  drawerPaper: {
    backgroundColor: "white",
  },
})

const Header = () => {
  const classes = useStyles()
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  const [expanded, setExpanded] = React.useState(false)

  const [open, setOpen] = React.useState(false)

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }
  return (
    <header
      style={{
        position: "absolute",
        top: "0px",
        left: "0px",
        zIndex: 1300,
        width: "100%",
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        style={{
          boxShadow: "0px 4px 12px -8.5px rgba(0,0,0,0.7)",
          backgroundColor: "white",
        }}
      >
        <Toolbar
          style={{
            backgroundColor: "white",
            height: "40px",
            paddingRight: "0px",
            paddingLeft: "0px",
          }}
        >
          {smDown ? (
            ""
          ) : (
            <Container
              maxWidth="lg"
              style={{
                display: "flex",
              }}
            >
              <Link to="/">
              
                <img 
                src={logo}
                width={200}
                style={{paddingTop:"26px"}}
               ></img>
              </Link>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Link to={"/"}>
                  <Text
                    variant={"body2"}
                    className={classes.link}
                    style={{
                      paddingRight: "16px",
                     
                    }}
                  >
                    {" "}
                    HOME{" "}
                  </Text>
                </Link>
                <Link to={"/mission"}>
                  <Text
                    variant={"body2"}
                    className={classes.link}
                    style={{
                  
                      paddingLeft: ".2rem",
                    }}
                  >
                    OUR MISSION
                  </Text>
                </Link>
                <Link to={"/contactUs"}>
                  <Text
                    variant={"body2"}
                    className={classes.link}
                    style={{
                      paddingLeft: "1rem",
                    }}
                  >
                    {" "}
                    CONTACT US{" "}
                  </Text>{" "}
                </Link>
                <Link to={"https://play.google.com/store/apps/details?id=ai.unicode.dfs"}>
                  <Button
                    variant="contained"
                    style={{
                      borderRadius: "80px",
                      backgroundColor: "#3978E4",
                      height: "35px",
                      paddingLeft: "17px",
                      paddingRight: "17px",
                      textTransform: "none",
                      top: "2px",
                      marginLeft: "20px",
                    }}
                  >
                    <Text
                      variant={"body2"}
                      style={{
                        color: "white",
                      }}
                    >
                      JOIN US
                    </Text>
                  </Button>
                </Link>{" "}
              </Grid>
            </Container>
          )}
        </Toolbar>
      </AppBar>
      {smDown ? (
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <AppBar position="fixed" style={{ backgroundColor: "white" }}>
            <Toolbar
              style={{
                backgroundColor: "white",
                height: "20px",
              }}
            >
              <Link to="/">
                <img
                  src={image}
                  style={{
                    height: "50px",
                    width: "auto",
                    marginTop: "2.5ch",
                  }}
                  alt="zamzam"
                />
              </Link>
              <IconButton
                styly={{
                  backgroundColor: "white",
                  marginLeft: "170px",
                }}
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerOpen}
              >
                <MenuIcon style={{ color: "#3978E4", marginLeft: "170px" }} />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Drawer
            anchor="right"
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div style={{ backgroundColor: "white" }}>
              <IconButton
                onClick={handleDrawerClose}
                style={{ color: "#3978E4" }}
              >
                <Link to="/">
                  <img
                    src={image}
                    style={{
                      height: "50px",
                      width: "auto",
                      paddingRight: "180px",
                      marginTop: "10px",
                    }}
                    alt="dfs"
                  />
                </Link>
                {theme.direction === "ltr" ? <CloseIcon style={{}}/> : <CloseIcon />}
              </IconButton>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <Link to={"/"}>
                <Text
                  variant={"h6"}
                  className={classes.link}
                  onClick={handleDrawerClose}
                  style={{
                    paddingLeft: "1rem",
                    paddingTop: 15,
                    fontWeight: "normal",
                  }}
                >
                  {" "}
                  HOME{" "}
                </Text>
              </Link>
              <Link to={"/mission"}>
                <Text
                  variant={"h6"}
                  onClick={handleDrawerClose}
                  className={classes.link}
                  style={{
                    paddingTop: 15,
                    fontWeight: "normal",
                    paddingLeft: "1rem",
                  }}
                >
                  OUR MISSION
                </Text>
              </Link>
              <Link to={"/contactUs"}>
                <Text
                  variant={"h6"}
                  className={classes.link}
                  onClick={handleDrawerClose}
                  style={{
                    paddingTop: 15,
                    fontWeight: "normal",
                    paddingLeft: "1rem",
                  }}
                >
                  {" "}
                  CONTACT US{" "}
                </Text>{" "}
              </Link>
              <br />
            </div>
          </Drawer>
        </div>
      ) : (
        ""
      )}
    </header>
  )
}

export default Header
